import { forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  Slide,
} from "@material-ui/core";
import "./style.css";
import CloseIcon from "@material-ui/icons/Close";
import { trackButtonClick } from "utils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const HumanizeInfoDialog = (props) => {
  const { dialogOpen, setDialogOpen } = props;

  const handleClose = (e) => {
    trackButtonClick("HumanizeInfoDialog", "Close");
    e.stopPropagation();
    e.preventDefault();
    setDialogOpen(false);
  };

  return (
    <>
      <Dialog
        open={dialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        PaperProps={{
          style: {
            zIndex: "1200 !important",
            borderRadius: "32px",
          },
        }}
        maxWidth="xs"
        BackdropProps={{ style: { zIndex: "1200 !important" } }}
      >
        <DialogContent style={{ zIndex: "1200 !important" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="humanize-info-close" onClick={handleClose}>
              <CloseIcon
                overlineThickness={20}
                strikethroughThickness={7}
                fontSize="28px"
              />
            </div>
            <div className="humanize-info-dialog">
              <div className="title">Success!</div>
              <div className="sub-title">
                We have successfully humanized your work. You can use this
                feature as many times as you’d like to get the{" "}
                <b>highest human percentage</b> on a detection tool.
              </div>
              <div className="okay-btn hover-zoom" onClick={handleClose}>
                View Humanized Note (OK)
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HumanizeInfoDialog;
